<template>
  <router-view />
</template>

<style lang="scss">
@import "assets/sass/plugins";
@import "assets/sass/style";
</style>
